import moment from 'moment';
import { ZoomPropertyViewModel } from './zoom-property-view-model';
import { DateTimeMetaDataInterface, MessageContainerInterface, ModifiedSubscriberInterface } from '@nts/std/interfaces';

export class DateTimeZoomPropertyViewModel extends ZoomPropertyViewModel<Date>  {

  constructor(propertyMetaData: DateTimeMetaDataInterface, modifiedSubscriber: ModifiedSubscriberInterface) {
    super(propertyMetaData, modifiedSubscriber);

  }

  override removeError(item: MessageContainerInterface) {
    throw new Error("Method not implemented.");
  }

  setValue(propertyValue: Date) {
    if (propertyValue === null) {
      this.typedValue = null;
    } else {
      // TODO
      // let ic = propertyValue as IConvertible;
      // if (ic == null)
      // {
      //     throw new ArgumentException();
      // }

      // this.typedValue = ic.ToDateTime(CultureInfo.InvariantCulture);
      this.typedValue = moment(propertyValue, 'YYYY-MM-DD').toDate();
    }
    this.modifiedSubscriber.notifyModified();
  }

  private internalDateTimeValues!: Array<Date>|null;

  setDateTimeValues(valuesToSet: Array<Date>) {
      if (this.internalDateTimeValues != valuesToSet) {
          this.internalDateTimeValues = valuesToSet;
          this.modifiedSubscriber.notifyModified();
      }   
  }

  get dateTimeValues(): Array<Date>|null {
      return this.internalDateTimeValues;
  }
}
